import { render, staticRenderFns } from "./ModificaDomanda.vue?vue&type=template&id=87d8ee58&scoped=true&"
import script from "./ModificaDomanda.vue?vue&type=script&lang=js&"
export * from "./ModificaDomanda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d8ee58",
  null
  
)

export default component.exports